import { useQuery } from "@tanstack/react-query";
import { getCancellationCondition } from "../../admin/dictionaries/cancellationConditionsApi";

const cancellationConditionsKey = "cancellation-conditions";

export const useCancellationCondition = (cancellationConditionId: string | null) => {
  const { data, isLoading } = useQuery({
    queryKey: [cancellationConditionsKey],
    queryFn: ({ signal }) =>
      !cancellationConditionId ? null : getCancellationCondition(cancellationConditionId, signal),
    enabled: cancellationConditionId !== null,
  });

  return {
    isLoading,
    cancellationCondition: data,
  };
};
